import { firebase } from "../../../services/firebase/firebase"
import { useNavigate } from "react-router-dom"

export default () => {
    const navigate = useNavigate()
    return () =>
        firebase.auth
            .signOut()
            .then(() => navigate("/signin"))
            .catch(console.error)
}
